import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AuthGuard } from '../auth.guard.service';
import { Router } from '@angular/router';
import { SimpleObject, SimpleService } from '../simple.service';
import { WeekRangeSharedService } from '../services/week-range-shared.service';
import { WeekRangeValues } from '../week-range-selector/week-range-selector.component';
import { CalendarWeek } from '../week-range-selector/week-range-selector.component';
import { UserDetails } from '../models/user-details';
import { ProfileService } from '../services/profile.service';
import { ClearStorage } from '../services/clear-service.service';
//import { AppComponent } from '../app.component';
import { InfoCardsService } from '../services/info-card.service';
import { DxButtonModule, DxDropDownButtonModule, DxPopupModule, DxToolbarModule } from 'devextreme-angular';
import { ProfileComponent } from '../settings/profile/profile.component';
import { ConfigEditorComponent } from '../settings/config-editor/config-editor.component';
import { PriceWatcherComponent } from '../price-watcher/price-watcher.component';
import { CrudService } from '../services/crud.service';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { JourneyService } from '../services/journey.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    providers: [SimpleService, AuthGuard, ProfileService],
    imports: [ CommonModule, DxToolbarModule, DxButtonModule, DxDropDownButtonModule, DxPopupModule,
      ProfileComponent, ConfigEditorComponent, PriceWatcherComponent ],
    standalone: true,
    encapsulation: ViewEncapsulation.Emulated
})
export class HeaderComponent implements OnInit {
   profileSettings: SimpleObject[];
   userName: string;
   weekRange: WeekRangeValues | undefined | null;
   weekRangeHistoric: WeekRangeValues | undefined | null = undefined;
   endDate: string | null = null;
   displayWeekRange: boolean = false;
   userLoggedInDetails: UserDetails;
   infoCardsCountWarnings:any;
   infoCardsCountErrors:any;
   /** Controls the Configuration editor popup (opened from the profile dropdown). */
   configVisible: boolean = false;
   /** Controls the Price Watcher popup (opened from the header search-prices button). */
   priceWatcherVisible: boolean = false;
   /** Only users holding the pf_watcher role get the Price Watcher button. */
   priceWatcherAllowed: boolean = false;
   @Output() toggleDrawer = new EventEmitter<void>();
  // @ViewChild(AppComponent) appComponent: AppComponent;
buttonOptions: any = {
  icon: "menu",
  onClick: () => this.toggleDrawer.emit()
};
  constructor(private auth: AuthGuard,
      private router: Router,
      private weekRangeSharedService: WeekRangeSharedService,
      private simpleService: SimpleService,
      private profileService: ProfileService,
      private clearStorage: ClearStorage,
      private crudService: CrudService,
      public infoCardsService: InfoCardsService,
      private journeyService: JourneyService
      ) {
        }

  ngOnInit(): void {
    this.checkPriceWatcherAccess();
    this.autoStartJourney();
    //track url
    this.infoCardsService.fetchInfoCards();
    this.infoCardsService.infoCardsCountByTypeSubject.subscribe(countsByType => {
      this.infoCardsCountWarnings = countsByType['warning'] || 0; //  for getting warning count
      this.infoCardsCountErrors = countsByType['error'] || 0; //  for getting error count
    });
    const targetUrl = "/slotting"
    let previousUrl = this.router.url;
    if(localStorage.getItem('weekRangeValues') !== null) {
    const savedWeekRange = localStorage.getItem('weekRangeValues');
    this.weekRangeSharedService.selectedWeekRange$.subscribe(weekRange => {
      this.weekRange = weekRange;
      if (weekRange) {
       this.calculateEndDate();
       this.saveToLocalStorage(); // Add this line after modifying values
      }
    });
    this.loadFromLocalStorage();
    this.weekRange = JSON.parse(savedWeekRange as string) as WeekRangeValues;
    this.calculateEndDate();  // calculate the end date based on the retrieved range
    this.saveToLocalStorage();
    this.displayWeekRange = (this.router.url === targetUrl);
    }
    //subscribe to navigation event
    this.router.events.subscribe(event => {
      if(this.router.url === targetUrl && this.weekRangeHistoric !== undefined){
        this.weekRange = this.weekRangeHistoric;
        this.weekRangeHistoric = undefined;
      }
      this.displayWeekRange = (this.router.url === targetUrl);
      previousUrl = this.router.url;
    });
    this.profileSettings = this.simpleService.getProfileSettings();
         this.auth.userNameChanged.subscribe((newUserName: string) => {
    this.userName = newUserName;
  });
  }
  navigateToNotifications():void{
    this.router.navigate(['/']);
  }

  /**
   * Starts the guided journey for a user who has never been shown it — the tour is no
   * longer triggered by hand, the profile dropdown's "Take the tour" item replays it.
   *
   * Waits for the session token for the same reason checkPriceWatcherAccess does: the
   * header initialises before the auth guard's /verify call has stored it. Starting
   * early would navigate an unauthenticated visitor to the first phase's page instead
   * of letting the guard bounce them to login.
   */
  private autoStartJourney(attempt: number = 0): void {
    if (this.journeyService.hasSeen()) {
      return;
    }
    if (!sessionStorage.getItem('token')) {
      if (attempt < 20) {
        setTimeout(() => this.autoStartJourney(attempt + 1), 1000);
      }
      return;
    }
    this.journeyService.startIfNotSeen();
  }

  /**
   * Shows the Price Watcher button only for users holding the pf_watcher
   * role (the API endpoints enforce the same role). The header initialises
   * before the auth guard's /verify call has stored the session token, so
   * wait for the token before asking the API — the access endpoint answers
   * 200 {allowed:false} (not an error) to a missing token, which would
   * otherwise hide the button until the next full page load.
   */
  private checkPriceWatcherAccess(attempt: number = 0): void {
    const token = sessionStorage.getItem('token');
    if (!token) {
      if (attempt < 20) {
        setTimeout(() => this.checkPriceWatcherAccess(attempt + 1), 1000);
      }
      return;
    }
    this.crudService.newGetData(`${environment.baseApiUrl}price-watcher/access`).subscribe({
      next: (response: any) => {
        this.priceWatcherAllowed = response?.data?.allowed === true;
      },
      error: () => {
        if (attempt < 20) {
          setTimeout(() => this.checkPriceWatcherAccess(attempt + 1), 3000);
        }
      }
    });
  }
  loadFromLocalStorage(): void {
    const storedWeekRange = localStorage.getItem('weekRange');
    if (storedWeekRange) {
      this.weekRange = JSON.parse(storedWeekRange) as WeekRangeValues;
    }
    const storedEndDate = localStorage.getItem('endDate');
    if (storedEndDate) {
      this.endDate = storedEndDate;
    }
    const storedDisplayWeekRange = localStorage.getItem('displayWeekRange');
    if (storedDisplayWeekRange) {
      this.displayWeekRange = storedDisplayWeekRange === 'true'; // because it will be stored as a string
    }
  }
  saveToLocalStorage(): void {
    if (this.weekRange) {
      localStorage.setItem('weekRange', JSON.stringify(this.weekRange));
    }
    if (this.endDate) {
      localStorage.setItem('endDate', this.endDate);
    }
    localStorage.setItem('displayWeekRange', String(this.displayWeekRange));
  }
  userImage(){
    const userLoggedIn = localStorage.getItem('userDetails');
    const userLoggedInDetails = userLoggedIn ? JSON.parse(userLoggedIn) : null;
    if(userLoggedInDetails && userLoggedInDetails.data) {
      this.userName = userLoggedInDetails.data.username;
      if(userLoggedInDetails?.data?.location_id === 7){
        return '../../assets/independent-liquour-retailers.png';
      }
      else if(userLoggedInDetails?.data?.location_id === 8){
        return '../../assets/thirsty_camel_logo.png';
      }
      else if(userLoggedInDetails?.data?.location_id === 3){
        return '';
      }
      else if(userLoggedInDetails?.data?.location_token === 'HEAPS_NORMAL_PTY_LTD'){
        // Key on the stable location_token, not the auto-increment location_id — the
        // numeric id differs per environment (Heaps Normal is 44 in dev but a different
        // id in prod), so an id check only matched in dev and the logo never showed in prod.
        return '../../assets/heaps-normal-logo.jpg';
      }
      return; // return a default image or null here
    }
    return;
  }

  itemClick(e: any) {
    if(e.itemData.name === 'Logout') {
      this.auth.logOut();
      this.clearStorage.logout();
    } else if(e.itemData.name === 'Profile') {
      this.profileService.setEditProfile(true);
    } else if(e.itemData.name === 'Configuration') {
      this.configVisible = true;
    } else if(e.itemData.name === 'Take the tour') {
      this.journeyService.start();
    }
  }

  checkComparison() {
    return true;
  }
  navigateToDocumentation() {
    //window.open('https://develop-promoflo.s3.ap-southeast-2.amazonaws.com/documentation/documentation_how_to.html', '_blank');
  }
  //calculates end date of the selected date range. i.e. start date + week count
  private calculateEndDate() {
    if (this.weekRange) {
      const calendarWeeks = JSON.parse(localStorage.getItem('calender-weeks') || '[]') as CalendarWeek[];
      const startWeekObject = calendarWeeks.find(week => week.start_date.toString() === this.weekRange?.startWeek);

      if (startWeekObject) {
        const startDate = new Date(startWeekObject.start_date);
        startDate.setDate(startDate.getDate() + (this.weekRange.numberOfWeeks * 7) - 1);
        this.endDate = startDate.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
      }
    }
  }
}
